export var SLIDES_PART = 0.2;
export var SLIDES_MOBILE = 2;
export var SLIDES_TABLET = 3;
export var SLIDES_DESKTOP = 4;
export var CARD_WIDTH = {
  mobile: 128,
  desktop: 180
};